import type { FC } from "react";

import { cn } from "#lib/utils";

interface NinetyNineStudLogoProps {
  className?: string;
}

export const NinetyNineStudLogo: FC<NinetyNineStudLogoProps> = ({
  className,
}) => {
  return (
    <svg
      className={cn("h-auto w-auto", className)}
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 409 364"
      fill="none"
    >
      <g clipPath="url(#clip0_55_3)">
        <path
          d="M358.57 144.83L343.26 143.66L320.18 197.26L391.78 244.4L294.63 257.77L319.59 315.77L240.98 285.47L197.64 349.54L166.32 314.76L92.45 363.86L117.11 284.9L9.63 304.67L70.07 246.96L0 229.3L57.8 200.17L39.09 183.1L37.8 152.48L14.28 125.38L28.63 110.52L15.46 93.62L60.01 58.03L70.79 71.4L83.08 55.87L157.03 20.46L221.31 0.67L276.52 0L296.57 17.92L354.8 17.71L407.63 51.35L408.71 104.39L358.57 144.83Z"
          fill="black"
        />
        <path
          d="M136 228.56L110.89 229.11L106.13 219.59L111.6 208.85L140.01 204.46L156.62 216.23L177.64 215.09L278.92 140.96L292.1 148.95L305.81 146.12L311.39 154.68L296.8 175.54L300.84 187.36L288.55 208.95L288.71 217.02L231.28 262.23L194 300.75L180.28 278L139.91 301.38L155.1 250.11L136 228.56Z"
          fill="white"
        />
        <path
          d="M343.82 33.3201L287.67 31.8101L270.49 17.1101L222.15 16.3101L157.23 35.2101L88.8699 68.5101L69.5699 87.7401L59.4499 75.9301L32.9299 97.2001L44.5899 112.69L31.6299 124.28L49.5699 144.95L57.1099 179.08L89.1299 197.96L118.01 187.55L101.96 170.46L143.26 171.64L141.09 149.06L168.11 155.7L169.48 98.5601L214.07 145.46L229.35 130.74L224.58 114.53L202.15 100.55L201.35 98.1501L249.79 111.06L283.36 78.7201L289.16 117.34L355.68 126.22L391.77 99.2001L389.92 62.5201L343.81 33.3301L343.82 33.3201ZM88.9399 127.31L77.8499 138.32L66.8999 125.52L54.9999 135.88L45.3099 124.82L57.6599 113.06L46.6799 99.3801L57.0799 90.6901L68.9599 103.91L82.4299 89.3501L92.4599 100.53L78.7399 114.24L88.9499 127.31H88.9399ZM151.13 132.3L138.45 141.56L129.8 128.63L118.15 139.4L109.71 127.36L121.55 116.27L110.96 100.44L121.98 91.3701L132.44 106.05L150.34 90.7201L159.89 103.22L141.07 118.17L151.13 132.28V132.3Z"
          fill="white"
        />
      </g>
      <defs>
        <clipPath id="clip0_55_3">
          <rect width="408.71" height="363.86" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};
